import Vuex from 'vuex';
import { shallowMount, createLocalVue } from '@vue/test-utils';
import boostMixin from '../../../../mixins/boostMixin';
import BoostModule from './BoostModule';
import { currency } from '../../../../filters';
import { getObjProperty } from "../../../../utilities/mrVueUtils";

const localVue = createLocalVue();
localVue.use(Vuex);
localVue.filter('currency', currency);

const boosts = [
  {
    id: 1,
    name: 'Boost 1',
    price: 5,
    inventory_status: 'active',
    navTitle: 'NavTitle1',
    imagery: {
      standard: {
        url: 'www.url',
        alt_text: 'Alt Text'
      }
    }
  },
  {
    id: 2,
    name: 'Boost 2',
    price: 5,
    inventory_status: 'active',
    navTitle: 'NavTitle2',
    imagery: {
      standard: {
        url: 'www.url',
        alt_text: 'Alt Text'
      }
    }
  },
  {
    id: 3,
    name: 'Boost 3',
    price: 5,
    inventory_status: 'active',
    navTitle: 'NavTitle3',
    imagery: {
      standard: {
        url: 'www.url',
        alt_text: 'Alt Text'
      }
    }
  }
];

const createWrapper = (store) => {
  return shallowMount(BoostModule, {
    store,
    localVue,
    mixins: [ boostMixin ],
    provide: {
      getObjProperty
    }
  });
};

let addToCartMock = jest.fn();
let initBoostRecommendationsMock = jest.fn();
let initWaitlistsMock = jest.fn();
let setSelectedBoostMock = jest.fn();
let setShowBoostOptionsMock = jest.fn();
let showModalMock = jest.fn();
let setAttachableProdIdMock = jest.fn();

let storeObj = {
  modules: {
    cart: {
      namespaced: true,
      state: {
        addingProduct: false
      },
      actions: {
        addToCart: addToCartMock
      }
    },

    customer: {
      namespaced: true,
      state: { cdata: {} }
    },

    modal: {
      namespaced: true,
      actions: {
        showModal: showModalMock
      }
    },

    pdp: {
      namespaced: true,
      mutations: {
        setAttachableProdId: setAttachableProdIdMock
      }
    },

    waitlist: {
      namespaced: true,
      state: { waitlists: [] },
      actions: {
        initWaitlists: initWaitlistsMock
      },
      getters: {
        isOnWaitlist: () => () => false
      }
    },

    xsell: {
      namespaced: true,
      state: {
        boostRecommendations: boosts,
        selectedBoost: {
          id: 1,
          name: 'Boost 1',
          imagery: {
            thumb: {
              url: 'www.url',
              alt_text: 'Alt Text'
            }
          }
        }
      },
      actions: {
        initBoostRecommendations: initBoostRecommendationsMock
      },
      mutations: {
        setSelectedBoost: setSelectedBoostMock,
        setShowBoostOptions: setShowBoostOptionsMock
      }
    }
  }
};

function clearMocks() {
  addToCartMock.mockClear();
  initBoostRecommendationsMock.mockClear();
  initWaitlistsMock.mockClear();
  setSelectedBoostMock.mockClear();
  setShowBoostOptionsMock.mockClear();
  showModalMock.mockClear();
  setAttachableProdIdMock.mockClear();
}

describe('BoostModule', () => {
  afterEach(() => {
    clearMocks();
  });

  test('general snapshot', () => {
    let store = new Vuex.Store(storeObj);
    const wrapper = createWrapper(store);
    expect(wrapper.html()).toMatchSnapshot();
  });



  describe('computed', () => {
    describe('introText', () => {
      test('text when selectedBoost.recommended is true', () => {
        let customText = "to lock in color";
        let localThis = {
          selectedBoost: {
            recommended: true,
            wantText: customText
          }
        };

        expect(BoostModule.computed.introText.call(localThis)).toEqual(`You mentioned wanting ${customText}&mdash;add a Pro&nbsp;Boost`);
      });

      test('text when selectedBoost.recommended is false', () => {
        let customText = "to lock in color";
        let localThis = {
          selectedBoost: {
            recommended: false,
            wantText: customText
          }
        };

        expect(BoostModule.computed.introText.call(localThis)).toEqual(`Want ${customText}?&mdash;add a Pro&nbsp;Boost`);
      });
    });

  });

  describe('methods', () => {

    describe('showBoostModal', () => {
      test('expected method calls with arguments', () => {
        let store = new Vuex.Store(storeObj);
        const wrapper = createWrapper(store);

        wrapper.vm.showBoostModal();
        expect(showModalMock).toHaveBeenCalledTimes(1);
        expect(showModalMock.mock.calls[0][1]).toEqual({ component: './Dashboard/Welcome/ReturnCustomer/BoostModal', theme: 'no-padding' });
      });
    });

    describe('addBoost', () => {
      test('call expected methods in happy path', () => {
        let store = new Vuex.Store(storeObj);
        const wrapper = createWrapper(store);

        wrapper.vm.addBoost();
        expect(addToCartMock).toHaveBeenCalledTimes(1);
        expect(addToCartMock.mock.calls[0][0]).toEqual(expect.any(Object), { productId: 1, ctaSource: 'boost-module', cartType: 'active' });
      });

      test('stop execution early when boostChecked is true', () => {
        let store = new Vuex.Store(storeObj);
        const wrapper = createWrapper(store);
        wrapper.setData({ boostChecked: true });

        wrapper.vm.addBoost();
        expect(addToCartMock).toHaveBeenCalledTimes(0);
      });

      test('successful call', (done) => {
        storeObj.modules.cart.actions.addToCart = jest.fn(() => {
          return Promise.resolve();
        });

        let store = new Vuex.Store(storeObj);
        const wrapper = createWrapper(store);

        wrapper.vm.addBoost();

        wrapper.vm.$nextTick(() => {
          wrapper.vm.$nextTick(() => {
            expect(wrapper.vm.boostAdded).toEqual(true);
            done();
          });
        });
      });

      test('unsuccessful call', (done) => {
        storeObj.modules.cart.actions.addToCart = jest.fn(() => {
          return Promise.reject();
        });

        let store = new Vuex.Store(storeObj);
        const wrapper = createWrapper(store);

        wrapper.vm.addBoost();

        //- this works, but I don't think its a good practice,
        //- ran out of time to figure out a better approach
        wrapper.vm.$nextTick(() => {
          wrapper.vm.$nextTick(() => {
            wrapper.vm.$nextTick(() => {

              expect(wrapper.vm.boostAdded).toEqual(false);
              expect(wrapper.vm.boostChecked).toEqual(false);
              done();
            });
          });
        });
      });
    });
  });
});
